import RegisterMember from "./RegisterMember";
import RegisterMemberRoute from "./RegisterMemberRoute";
import registerMemberSaga from "./saga";
import registerMember_reducer, { setMerchant } from "./slice";

export { RegisterMember, registerMemberSaga, registerMember_reducer, setMerchant };
export default RegisterMemberRoute;
